'use client'

import { useRouter } from 'next/navigation'
import React from 'react'
import { useGlobalSearch } from '../provider/global-search-provider'

type Bindings = Array<{
  key: string
  action: () => void
  ctrlKey?: boolean
}>

export function KeyboardBindings() {
  const { onOpenSearch } = useGlobalSearch()
  const router = useRouter()

  const bindings: Bindings = [
    {
      key: 'k',
      action: () => onOpenSearch(),
      ctrlKey: true,
    },
    {
      key: 'p',
      action: () => router.push('/account/licenses'),
      ctrlKey: true,
    },
    {
      key: 'b',
      action: () => router.push('/account/billing'),
      ctrlKey: true,
    },
    {
      key: 's',
      action: () => router.push('/account/settings'),
      ctrlKey: true,
    },
  ]

  React.useEffect(() => {
    const down = (e: KeyboardEvent) => {
      for (const binding of bindings) {
        if (e.key === binding.key && (binding.ctrlKey ? e.ctrlKey || e.metaKey : true)) {
          e.preventDefault()
          binding.action()
        }
      }
    }

    document.addEventListener('keydown', down)
    return () => document.removeEventListener('keydown', down)
  }, [])

  return <></>
}
